module.exports = __webpack_public_path__ + "img/PL08799.a8ea7eb6.png";